/**
 * ============================================================================
 * NewbannerFormTemplete (MVC feature barrel)
 * ============================================================================
 * Public entry kept at NewbannerFormTemplete.tsx so existing imports stay
 * stable (hero, FAQ, affiliate, industry-aligned banners).
 *
 * Wire: NewbannerFormTemplete → SectionErrorBoundary → controller → view
 * Form: ProgramDetailsOpenRfi → useProgramDetailsOpenRfiController
 * ============================================================================
 */
"use client";

import { SectionErrorBoundary } from "@/components/common/ErrorBoundary";
import { useNewbannerFormTempleteController } from "./controller/useNewbannerFormTempleteController";
import NewbannerFormTempleteView from "./view/NewbannerFormTempleteView";
import type { NewbannerFormTempleteProps } from "./model/newbannerFormTemplete.types";

export type {
  NewbannerFormTempleteProps,
  NewbannerFormTempleteViewModel,
} from "./model/newbannerFormTemplete.types";

function NewbannerFormTempleteInner(props: NewbannerFormTempleteProps) {
  const viewModel = useNewbannerFormTempleteController(props);
  return <NewbannerFormTempleteView {...viewModel} />;
}

export default function NewbannerFormTemplete(
  props: NewbannerFormTempleteProps,
) {
  return (
    <SectionErrorBoundary sectionName="NewbannerFormTemplete">
      <NewbannerFormTempleteInner {...props} />
    </SectionErrorBoundary>
  );
}
